import React, { useState } from "react";
import Footer from "../components/common-components/footer";
import Header from "../components/common-components/header";
import LogoutModal from "./../components/common-components/logout-warning";
import { Toaster } from "react-hot-toast";
import "./customer.scss";

export interface Props {
  children: React.ReactNode;
}

const CustomerLayout: React.FC<Props> = ({ children }) => {
  const [checkLogout, setCheckLogout] = useState(false);

  return (
    <div className="customer-layout">
      <Header setCheckLogout={setCheckLogout}></Header>
      <LogoutModal
        show={checkLogout}
        onHide={() => setCheckLogout(false)}
        dialogClassName={"modal_width"}
      />
      <div className="content">{children}</div>
      <Toaster
        position="bottom-right"
        reverseOrder={false}
        toastOptions={{
          style: {
            backgroundColor: "#00B38F",
            color: "#fff",
          },
        }}
      />
      <Footer></Footer>
    </div>
  );
};

export default CustomerLayout;
